
class ItemSet {
  constructor (keyCb, filterContext) {
    this.keyCb = keyCb
    this.items = new Map()
    this.loadedPages = null
    this.total = 0
    this.last = false
    this.sort = null
    this.page = 0
    this.filter = filterContext || {
      search: ''
    }
    this.filterChanged = true
    this.processing = false
  }
  setItems (data, cxt) {
    let self = this
    const concatMaps = function (map, ...iterables) {
      for (const iterable of iterables) {
        for (const item of iterable) {
          map.set(self.keyCb(item), item)
        }
      }
    }
    if (JSON.stringify(this.filter) === JSON.stringify(cxt)) {
      this.processing = false
      if (this.loadedPages === null || data.first) {
        this.items = new Map()
      }
      let map = new Map(this.items)
      concatMaps(map, data.content)
      this.items = map
      this.last = data.last
      if (data.totalPages) {
        this.loadedPages = this.last === false ? data.number + 1 : data.totalPages
        this.total = data.totalElements
      } else {
        this.loadedPages = this.last === false ? data.number + 1 : this.loadedPages
        this.total = this.last === false ? this.getLoadedSize() + 1 : this.getLoadedSize()
      }
    }
  }
  getItems () {
    return Array.from(this.items.values())
  }
  getLoadedSize () {
    return this.items.size
  }
  getTotal () {
    return this.total
  }
  isLast () {
    return this.last
  }
  getFilter () {
    return this.filter
  }
  setFilter (cxt) {
    if (JSON.stringify(this.filter) !== JSON.stringify(cxt)) {
      this.loadedPages = null
      this.last = false
      this.page = 0
      this.filter = cxt
      this.filterChanged = true
    }
  }
  getSort () {
    return this.sort
  }
  setSort (sort) {
    if (JSON.stringify(this.sort) !== JSON.stringify(sort)) {
      this.loadedPages = null
      this.last = false
      this.page = 0
      this.sort = sort
      this.filterChanged = true
    }
  }
  isChanged () {
    return this.filterChanged
  }
  clearChanged () {
    this.filterChanged = false
  }
  start () {
    this.processing = true
  }
  stop () {
    this.processing = false
  }
  isProcessing () {
    return this.processing
  }
  nextPage () {
    if (!this.isLast()) {
      if (this.page !== this.loadedPages) {
        if (this.getLoadedSize() < this.total) {
          this.page = this.loadedPages ? this.loadedPages : 0
          this.filterChanged = true
        }
      }
    }
  }
}

export default {
  ItemSet
}




// WEBPACK FOOTER //
// ./src/store/modules/StoreClasses.js